import React, { memo } from 'react'
import { useSelector } from 'react-redux'

import FilledCanvas from './FilledCanvas'
import BlankCanvas from './BlankCanvas'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { projectSelectors } from 'store/features/project/selectors'

interface IProps {
  canvasWrapperEl: HTMLDivElement | null
}

const CanvasContent: React.FC<IProps> = ({ canvasWrapperEl }) => {
  const projectId = useSelector(projectSelectors.id)
  const hasMediaItems = useSelector(projectDataSelectors.hasMediaItems)
  const hasAudioItems = useSelector(projectDataSelectors.hasAudioItems)

  const projectIsNotEmpty = hasMediaItems || hasAudioItems

  const isFilled = !!projectId && projectIsNotEmpty

  return isFilled ? (
    <FilledCanvas canvasWrapperEl={canvasWrapperEl} />
  ) : (
    <BlankCanvas />
  )
}

export default memo(CanvasContent)
